export default __webpack_public_path__ + "CircularPro-Book.3dcc7e40.otf";